module.exports = __webpack_public_path__ + "img/9788954425018.0e797cd8.jpg";